export enum BookPaymentStatusEnum {
    Carrinho = 1,
    AguardandoPagamento = 2,
    PagamentoEmCurso  = 3,
    Reprovado = 4,
    Aprovado = 5,
    Cancelado = 6
}